import * as Yup from "yup";
import { validateCpfCnpj } from "../../../../utils/inputValidations";

export const validationSchemaCPF = Yup.object({
  typeClient: Yup.string(),
  typeDocument: Yup.string(),
  cpf: Yup.string()
    .test(
      "cpf",
      "O número inserido não é valido, por favor verifique se foi digitado corretamente.",
      validateCpfCnpj
    )
    .required("Para continuar é necessário preencher este campo."),
  branches: Yup.string().required(
    "Para continuar é necessário preencher este campo."
  ),
});

export const validationSchemaDocumentInternational = Yup.object({
  typeClient: Yup.string(),
  typeDocument: Yup.string(),
  documentInternational: Yup.string()
    .required("Para continuar é necessário preencher este campo."),
  branches: Yup.string().required(
    "Para continuar é necessário preencher este campo."
  ),
});

export const validationSchemaCNPJ = Yup.object({
  typeClient: Yup.string(),
  typeDocument: Yup.string(),
  cnpj: Yup.string()
    .test(
      "cnpj",
      "O número inserido não é valido, por favor verifique se foi digitado corretamente.",
      validateCpfCnpj
    )
    .required("Para continuar é necessário preencher este campo."),
  company: Yup.string()
    .min(
      3,
      "Por favor, verifique se a razão social digitada possui entre 3 e 50 caracteres."
    )
    .max(
      50,
      "Por favor, verifique se a razão social digitada possui entre 3 e 50 caracteres."
    )
    .required("Para continuar é necessário preencher este campo."),
  branches: Yup.string().required(
    "Para continuar é necessário preencher este campo."
  ),
});
